import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const defaultColor = 'red'
const radius = 175
const diameter = Math.round(Math.PI * radius * 2)
const getOffset = (val = 0) => Math.round(((100 - Math.min(val, 100)) / 100) * diameter)

export default class Circle extends PureComponent {
  static propTypes = {
    children: PropTypes.element,
    values: PropTypes.array.isRequired,
    colors: PropTypes.array.isRequired,
    size: PropTypes.any /* string (100%) or number */,
    strokeWidth: PropTypes.number,
    percentSpacing: PropTypes.number,
    roundedStroke: PropTypes.bool
  }

  static defaultProps = {
    size: 100,
    strokeWidth: 25,
    percentSpacing: 10
  }

  render() {
    const { values, colors, size, strokeWidth, roundedStroke } = this.props
    const strokeLinecap = roundedStroke ? 'round' : 'butt'

    return (
      <Container>
        <Svg width={size} height={size} viewBox="-25 -25 400 400">
          {values.map((p, index) => {
            const strokeDashoffset = getOffset(p)
            return (
              <circle
                key={`p-${index}`}
                stroke={colors[index] || defaultColor}
                transform="rotate(-90 175 175)"
                cx="175"
                cy="175"
                r="175"
                strokeDasharray="1100"
                strokeWidth={strokeWidth}
                strokeDashoffset="1100"
                strokeLinecap={strokeLinecap}
                fill="none"
                style={{ strokeDashoffset }}
              />
            )
          })}
        </Svg>
        <TextContainer>{this.props.children}</TextContainer>
      </Container>
    )
  }
}

const Container = styled.div`
  position: relative;
  display: inline-flex;
`

const Svg = styled.svg``

const TextContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/features/circle/index.js